import React from 'react';
import './FetchingOverlay.scss';

export const FetchingOverlay = ({ isVisible, message = 'Fetching case details...' }) => {
  if (!isVisible) return null;

  return (
    <div className="fetching-overlay">
      <div className="fetching-overlay-content">
        {/* Animated Legal Scales - Main Focus */}
        <div className="legal-animation">
          <div className="scales-container">
            <div className="scale-beam"></div>
            <div className="scale-left-pan"></div>
            <div className="scale-right-pan"></div>
            <div className="scale-base"></div>
          </div>
          
          {/* Circular Progress */}
          <div className="circular-progress">
            <svg className="progress-ring" viewBox="0 0 120 120">
              <circle className="progress-ring-circle" cx="60" cy="60" r="54"></circle>
            </svg>
          </div>
        </div>

        {/* Loading Text */}
        <div className="loading-text-container">
          <h3 className="loading-title">{message}</h3>
          <p className="loading-subtitle">Please wait while we retrieve the information</p>
          
          {/* Animated Dots */}
          <div className="loading-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
};